import {defineStore} from 'pinia'
import axiosInstance from "@/services/api";
import {useApiSettingStore} from "@/stores/apiSettings";

export const useWikiStore = defineStore(
    "wiki",
    {
        state: () => ({
            /*** controller ***/
            controllerGetWikis: null,
            controllerGetWiki: null,
            /*** ***/

            wikis: null,
            arrayWikiInfinity: [],
            optionsWiki: null,
            wiki: null,
            allWiki: null,
            oldWiki: null,
            spinnerWiki: false
        }),
        actions: {
            getOptionsWiki() {
                return new Promise((resolve, reject) => {
                    axiosInstance.options('api/wikis/')
                        .then(res => {
                            this.optionsWiki = res.data
                            resolve(res)
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 500) {
                                useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                            }
                            reject(err)
                        })
                })
            },
            getWiki(id) {
                return new Promise((resolve, reject) => {
                    this.controllerGetWiki = new AbortController()
                    const config = {
                        signal: useWikiStore().controllerGetWikiGetters.signal
                    }
                    axiosInstance.get('api/wikis/' + id + '/', config)
                        .then(res => {
                            this.wiki = res.data
                            resolve(res)
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 500) {
                                useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                            }
                            reject(err)
                        })
                })
            },
            getWikis(payload) {
                return new Promise((resolve, reject) => {
                    this.controllerGetWikis = new AbortController()
                    const config = {
                        signal: useWikiStore().controllerGetWikisGetters.signal
                    }

                    let url = new URL(axiosInstance.defaults.baseURL + 'api/wikis/')

                    this.spinnerWiki = true
                    if (payload.queryParams !== null) {
                        let params = new URLSearchParams()
                        for (let i = 0; i < Object.keys(payload.queryParams).length; i++) {
                            params.set(Object.keys(payload.queryParams)[i], Object.values(payload.queryParams)[i])
                        }
                        url.search = params
                        axiosInstance.get(url.pathname + url.search, config)
                            .then(res => {
                                this.wikis = res.data
                                if (payload.queryParams.scroll) {
                                    this.arrayWikiInfinity.push(...res.data.results)
                                } else {
                                    this.arrayWikiInfinity = res.data.results
                                }
                                this.spinnerWiki = false
                                resolve(res)
                            })
                            .catch(err => {
                                this.spinnerWiki = false
                                if (err.response && err.response.status === 500) {
                                    useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                                }
                                reject(err)
                            })
                    } else {
                        axiosInstance.get(url.pathname, config)
                            .then(res => {
                                this.spinnerWiki = false
                                this.wikis = res.data
                                let a = []
                                a.push(...res.data.results);
                                this.arrayWikiInfinity = a
                                resolve(res)
                            })
                            .catch(err => {
                                this.spinnerWiki = false
                                if (err.response && err.response.status === 500) {
                                    useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                                }
                                reject(err)
                            })
                    }

                })
            },
            getWikisWithoutSetState(payload) {
                return new Promise((resolve, reject) => {
                    let url = new URL(axiosInstance.defaults.baseURL + 'api/wikis/')

                    this.spinnerWiki = true
                    if (payload.queryParams !== null) {
                        let params = new URLSearchParams()
                        for (let i = 0; i < Object.keys(payload.queryParams).length; i++) {
                            params.set(Object.keys(payload.queryParams)[i], Object.values(payload.queryParams)[i])
                        }
                        url.search = params
                        axiosInstance.get(url.pathname + url.search)
                            .then(res => {
                                resolve(res)
                            })
                            .catch(err => {
                                this.spinnerWiki = false
                                if (err.response && err.response.status === 500) {
                                    useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                                }
                                reject(err)
                            })
                    } else {
                        axiosInstance.get(url.pathname)
                            .then(res => {
                                resolve(res)
                            })
                            .catch(err => {
                                this.spinnerWiki = false
                                if (err.response && err.response.status === 500) {
                                    useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                                }
                                reject(err)
                            })
                    }

                })
            },
            createWiki(payload) {
                return new Promise((resolve, reject) => {
                    axiosInstance.post('/api/wikis/', payload)
                        .then(res => {
                            resolve(res)
                        })
                        .catch(err => {
                            reject(err)
                        })
                })
            },
            getAllWiki(payload) {
                return new Promise((resolve, reject) => {
                    let url = new URL(axiosInstance.defaults.baseURL + 'api/wikis/')

                    let params = new URLSearchParams()
                    for (let i = 0; i < Object.keys(payload.queryParams).length; i++) {
                        params.set(Object.keys(payload.queryParams)[i], Object.values(payload.queryParams)[i])
                    }
                    url.search = params
                    axiosInstance.get(url.pathname + url.search)
                        .then(res => {
                            this.allWiki = res.data
                            resolve(res)
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 500) {
                                useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                            }
                            reject(err)
                        })

                })
            },
            editWiki(payload) {
                return new Promise((resolve, reject) => {
                    axiosInstance.patch('api/wikis/' + payload.id + '/', payload)
                        .then(res => {
                            resolve(res)
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 500) {
                                useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                            }
                            reject(err)
                        })
                })
            },
            deleteWiki(id) {
                return new Promise((resolve, reject) => {
                    axiosInstance.delete('/api/wikis/' + id + '/')
                        .then(res => {
                            resolve(res)
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 500) {
                                useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                            }
                            reject(err)
                        })
                })
            }
        },
        getters: {
            wikisGetters: state => {
                return state.wikis
            },
            allWikiGetters: state => {
                return state.allWiki
            },
            oldWikiGetters: state => {
                return state.oldWiki
            },
            wikiGetters: state => {
                return state.wiki
            },
            arrayWikiInfinityGetters: state => {
                return state.arrayWikiInfinity
            },
            spinnerWikiGetters: state => {
                return state.spinnerWiki
            },
            optionsWikiGetters: state => {
                return state.optionsWiki
            },
            controllerGetWikisGetters: state => {
                return state.controllerGetWikis
            },
            controllerGetWikiGetters: state => {
                return state.controllerGetWiki
            }
        }
    })